import {
  initializeHrosTelemetry,
  type HrosTelemetryInitialization,
  type HrosEnvironment,
} from "@flash-tecnologia/hros-telemetry/bootstrap";

const supportedEnvironments: ReadonlySet<string> = new Set([
  "local",
  "staging",
  "preProduction",
  "production",
  "test",
]);

const resolveEnvironment = (stage: string | undefined): HrosEnvironment => {
  if (stage !== undefined && supportedEnvironments.has(stage)) {
    return stage as HrosEnvironment;
  }

  return "local";
};

const resolveSampleRate = (value: string | undefined): number => {
  if (value === undefined || value.trim() === "") {
    return 0;
  }

  const sampleRate = Number(value);
  return Number.isFinite(sampleRate) && sampleRate >= 0 && sampleRate <= 1 ? sampleRate : 0;
};

const environment = resolveEnvironment(process.env.STAGE);

export const hrosTelemetry: HrosTelemetryInitialization = initializeHrosTelemetry({
  connectionString: process.env.OBSERVABILITY_CONNECTION_STRING,
  environment,
  release: process.env.RELEASE,
  tracePropagationTargets: [
    globalThis.location?.origin ?? "localhost",
    /^https:\/\/(?:[^/]+\.)?flashapp\.(?:site|dev|services)(?:\/|$)/,
    /^https:\/\/(?:dev\.)?api\.flashapp\.com\.br(?:\/|$)/,
  ],
  tracesSampleRate: resolveSampleRate(process.env.OBSERVABILITY_TRACES_SAMPLE_RATE),
});

export { environment as hrosTelemetryEnvironment };
